import React from 'react';

import { Input, Form } from 'antd';

const formItemLayout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 12 },
};

const NameUpdateForm = (_, ref) => (
  <Form
    name="basic"
    className="gx-form-row0"
    ref={ref}
    {...formItemLayout}
  >
    <Form.Item
      label="First Name"
      name="first_name"
    >
      <Input />
    </Form.Item>
    <Form.Item
      label="Last Name"
      name="last_name"
    >
      <Input />
    </Form.Item>
  </Form>
);

export default React.forwardRef(NameUpdateForm);
